import { useState, useEffect } from "react";
import axios from "axios";
import {
  salvarCredenciais,
  lerCredenciais,
  limparCredenciais,
} from "./lib/cofre";
import { formatarLogin } from "./lib/cpf";

/*
  Tela de login (React + Tailwind CSS).
  Entrada padrão por CPF e senha (e-mail continua aceito para contas
  sem CPF cadastrado). Autentica no backend (POST /api/auth/login),
  guarda o token JWT e oferece a opção de salvar usuário/senha
  criptografados no navegador.
*/
function Login({ onLogin }) {
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [salvar, setSalvar] = useState(true);
  const [erro, setErro] = useState("");
  const [carregando, setCarregando] = useState(false);

  // Pré-preenche com as credenciais salvas (se existirem)
  useEffect(() => {
    lerCredenciais().then((cred) => {
      if (cred) {
        setLogin(formatarLogin(cred.email || ""));
        setSenha(cred.senha || "");
        setSalvar(true);
      }
    });
  }, []);

  const aoAlternarSalvar = (marcado) => {
    setSalvar(marcado);
    // Desmarcar remove imediatamente as credenciais salvas
    if (!marcado) limparCredenciais();
  };

  const entrar = async (e) => {
    e.preventDefault();
    setErro("");
    setCarregando(true);

    try {
      const resp = await axios.post("/api/auth/login", { login, senha });
      const { token, usuario } = resp.data;

      localStorage.setItem("token", token);
      localStorage.setItem("usuario", JSON.stringify(usuario));
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      // Salva ou limpa conforme a opção (o cofre guarda o login no campo email)
      if (salvar) await salvarCredenciais(login, senha);
      else limparCredenciais();

      onLogin(usuario);
    } catch (err) {
      setErro(
        err.response?.data?.erro || "Não foi possível conectar ao servidor."
      );
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <form
        onSubmit={entrar}
        className="w-full max-w-sm bg-white rounded-2xl shadow-2xl p-8"
      >
        <div className="flex flex-col items-center mb-6">
          <h1 className="text-2xl font-bold text-slate-800">IntegraReceitas</h1>
          <p className="text-sm text-slate-500 mt-1">
            Acesse com suas credenciais
          </p>
        </div>

        {erro && (
          <div className="mb-4 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2.5 text-center">
            {erro}
          </div>
        )}

        <label className="block text-sm font-semibold text-slate-700 mb-1.5">
          CPF
        </label>
        <input
          className="w-full mb-4"
          type="text"
          inputMode="text"
          autoComplete="username"
          value={login}
          onChange={(e) => setLogin(formatarLogin(e.target.value))}
          placeholder="000.000.000-00"
          title="Digite seu CPF (ou o e-mail, se ainda não tiver CPF cadastrado)"
          autoFocus
          required
        />

        <label className="block text-sm font-semibold text-slate-700 mb-1.5">
          Senha
        </label>
        <input
          className="w-full mb-4"
          type="password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          placeholder="••••••••"
          required
        />

        <label className="flex items-center gap-2 mb-5 cursor-pointer select-none">
          <input
            type="checkbox"
            checked={salvar}
            onChange={(e) => aoAlternarSalvar(e.target.checked)}
          />
          <span className="text-sm text-slate-600">
            Salvar usuário e senha neste dispositivo
          </span>
        </label>

        <button type="submit" className="btn w-full" disabled={carregando}>
          {carregando ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}

export default Login;
